import { Routes, Route, NavLink } from "react-router-dom";
import { Icon } from "@iconify/react";
import routes from "./routes";

export default function ThemeBuilder() {
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.items && route.items.length) {
        return getRoutes(route.items);
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  const tabs = routes.filter((r) => r.title);

  return (
    <div className="theme-builder-wrapper">
      <style>{`
        .theme-builder-tabs {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 6px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          margin-bottom: 20px;
          width: fit-content;
        }
        .theme-builder-tabs .tb-tab {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 9px 18px;
          font-size: 14px;
          font-weight: 500;
          color: #64748b;
          border-radius: 8px;
          text-decoration: none;
          transition: background 0.15s, color 0.15s, box-shadow 0.15s;
          white-space: nowrap;
        }
        .theme-builder-tabs .tb-tab:hover {
          color: #0f172a;
          background: #eef2f7;
        }
        .theme-builder-tabs .tb-tab.active {
          color: #0f172a;
          background: #ffffff;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06);
        }
        .theme-builder-tabs .tb-tab svg {
          font-size: 18px;
        }
      `}</style>

      <nav className="theme-builder-tabs" aria-label="Theme builder sections">
        {tabs.map((tab) => (
          <NavLink
            key={tab.key}
            to={`.${tab.route === "/" ? "" : tab.route}`}
            end={tab.route === "/"}
            className={({ isActive }) => `tb-tab ${isActive ? "active" : ""}`}
          >
            {tab.icon && <Icon icon={tab.icon} />}
            <span>{tab.title}</span>
          </NavLink>
        ))}
      </nav>

      <Routes>{getRoutes(routes)}</Routes>
    </div>
  );
}
